import React,{useState,useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import { Button,Table,Container,Row,Col,Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-regular-svg-icons';

import Loginheader from '../Loginheader';
import Menu from '../Menu';
import * as Common from '../Common';
import Dialog from '../Dialog';

function Master_isd_List(){ 
    const navigate = useNavigate();
    const [isMsgBox,setMsgBox] = useState(false); 
    const [msgText,setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [isdData, setIsdData] = useState([]);

    const [showAddNewBtn,setShowAddNewBtn] = useState(true);
    const [showAddEditForm,setAddEditFormShow] = useState(false);

    const [isd,setIsd] = useState("");
    const [isdName,setIsdName] = useState("");

    const [status,setStatus] = useState(0);
    const [ddActiveOptions,setDdActiveOptions] = useState([]);

    const [country,setCountry] = useState(0);
    const [ddCountryOptions,setDdCountryOptions] = useState([]);

    const [userRight,setUserRight] = useState([]);

    useEffect(()=>{
        if(onceRun){
            return;
        }else{
            Common.callApi(Common.apiRight,[sid,'all','CURRENCY'],function(result){
                let resp = JSON.parse(result);
                if(resp.query==="1"){
                    setUserRight(resp);
                }else{
                    navigate('/'); // no query right
                }
            });
            setDdActiveOptions([{name:'Active',value:"1"},{name:'Inactive',value:"0"}]);
            Common.callApi(Common.apiIsd,[sid,'listjson'],function(result){ 
                setIsdData(JSON.parse(result));
            });
            Common.callApi(Common.apiCountry,[sid,'ddlistjson'],function(result){ 
                setDdCountryOptions(JSON.parse(result));
            });
            setOnceRun(true);
        }
    },[onceRun,sid,navigate]);

    function getList(){
        Common.callApi(Common.apiIsd,[sid,'listjson'],function(result){ 
            setIsdData(JSON.parse(result));
        });
    }

    function addNew(){
        setIsd("");
        setIsdName("");
        setStatus(1);
        setCountry(1);
        setAddEditFormShow(true);
        setShowAddNewBtn(false); 
    }

    function fillEditForm(id){
        Common.callApi(Common.apiIsd,[sid,'detail',id],function(result){ 
            let resp = JSON.parse(result);
            setIsd(resp.isd);
            setIsdName(resp.isdName);
            setCountry(resp.countrySrno);
            setStatus(resp.active);
            setAddEditFormShow(true);
            setShowAddNewBtn(false); 

        });
    }

    function saveData(){
        if(isd==="" || isdName===""){
            setMsgText(Common.getMessage("MSG0006"));
            setMsgBox(true);
        } else {
            var object1 = {
                isd: isd,
                isdName: isdName,
                countrySrno: country,
                act: status
            };
            Common.callApi(Common.apiIsd,[sid,'save',JSON.stringify(object1)],function(result){ 
                setAddEditFormShow(false);
                setShowAddNewBtn(true);
                getList();
            });
        }
    }

    function cancelData(){
        setAddEditFormShow(false);
        setShowAddNewBtn(true);
    }

    return(
        <>
            <Loginheader></Loginheader>
            <Menu></Menu>
            <Container fluid >
                <Row>
                    <Col>
                        <h1>ISD Master </h1>
                    </Col>  
                </Row>
                {showAddNewBtn?
                    <Row>
                        <Col>
                            {userRight.add==="1"?
                                <Button  variant="outline-primary" size="sm"  onClick={addNew}>Add New</Button>   
                            :null}             
                        </Col>
                    </Row>
                :null
                }
                <Row><Col>&nbsp;</Col></Row>
                {showAddEditForm?
                    <Row>
                        <Col className="divContentCenter">
                            <div className="maxFormWidth">
                                <Form>
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Currency Code<span className="mandatory">*</span></Form.Label>
                                                <Form.Control type="text" placeholder="Currency Code"  maxLength={3}
                                                value={isd} onChange={(e)=>setIsd(e.target.value)} autoComplete="off" />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Currency Name<span className="mandatory">*</span></Form.Label>
                                                <Form.Control type="text" placeholder="Currency Name" maxLength={50}
                                                 value={isdName} onChange={(e)=>setIsdName(e.target.value)}  autoComplete="off"/>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Country</Form.Label>
                                                <Form.Select 
                                                    value={country}
                                                    onChange={(e)=>setCountry(e.target.value)}
                                                    >
                                                    {ddCountryOptions.map((res)=>
                                                        <option key={res.value} value={res.value}>{res.name}</option>
                                                    )}
                                                </Form.Select>
                                            </Form.Group>
                                            
                                        </Col>
                                        <Col>                                        
                                            <Form.Group>
                                                <Form.Label>Status</Form.Label>
                                                <Form.Select  
                                                    value={status}
                                                    onChange={(e)=>setStatus(e.target.value)}
                                                    >
                                                    {ddActiveOptions.map((res)=>
                                                        <option key={res.value} value={res.value}>{res.name}</option>
                                                    )}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row><Col>&nbsp;</Col></Row>
                                    <Row>
                                        <Col>
                                            <Button  variant="outline-success" size="sm"  onClick={()=>saveData()}>Save</Button>&nbsp;
                                            <Button  variant="outline-danger" size="sm"  onClick={()=>cancelData()}>Cancel</Button>
                                        </Col>
                                    </Row>
                                    <Row><Col>&nbsp;</Col></Row>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                :<>
                    <Row>
                        <Col>
                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        {userRight.edit==="1"? <th></th> :null}
                                        <th className="textRight">Code</th>
                                        <th>Name</th>
                                        <th>Country</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isdData.map((res) =>
                                        <tr key={res.isd_code}>
                                            {userRight.edit==="1"?
                                                <td className="textCenter" >
                                                    <span className="handCursor" onClick={()=>fillEditForm(res.isd_code) } >
                                                        <div className="colorThemeBlue"><FontAwesomeIcon icon={faEdit}  /></div>
                                                    </span>
                                                </td>
                                               :null
                                            }
                                            <td className="textRight">{res.isd_code}</td>
                                            <td>{res.isd_name}</td>
                                            <td>{res.cnt_name}</td>
                                            <td>{res.isd_active}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>                
                </>
                }


            </Container>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e)=> setMsgBox(false) }>
                    {msgText}
                </Dialog>
            </div>
        </>
    );
}
export default Master_isd_List; 